import { Attachment, ComposeMessageEditorErrorType } from "../../reducer.types";

/** Returns an error if the message length is invalid:
 * - If the message is left empty/untouched
 */
export const validateClinicianMessageLength = ({
    messageBody,
    messageSignature,
    originalGreeting,
    originalSignature,
    attachments,
}: {
    messageBody: string;
    messageSignature: string;
    attachments: Attachment[];
    originalGreeting: string;
    originalSignature: string;
}): Pick<ComposeMessageEditorErrorType, "messageLength"> => {
    const isBodyEmpty = messageBody.trim() === "";
    const isMessageEdited =
        `${messageBody.trim()}${messageSignature.trim()}` !==
        `${originalGreeting}${originalSignature}`;
    /**
     * A message is considered edited if the user
     * - somehow changed the body area to be different that the plain greeting
     * - attached a document
     */
    const hasBeenEdited = isMessageEdited || attachments.length > 0;
    return isBodyEmpty || !hasBeenEdited
        ? { messageLength: "EMPTY_MESSAGE" }
        : {};
};
